import React from 'react';
import './Footer.css';

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <div className="footer-connection">
          <div className="connection-dot" />
          <span>Connection: SECURE_AES_256</span>
        </div>
      </div>
      <div className="footer-right">
        <span>LIBRIS_OS_V2.6.4_STABLE</span>
        <div className="footer-divider" />
        <span>© 2026 101OBEX_CORP</span>
      </div>
    </footer>
  );
};
